const { fetchAllWordpress } = require('../../../../utils/fetch-wp');
const postCategories = require('../../../../data/categories.json');

async function getInitialProps(props) {
  try {
    const initialData = await fetchAllWordpress('posts');
    const initialTags = await fetchAllWordpress('tags');
    const parsedTags = initialTags.reduce((acc, { id, name }) => (
      {
        ...acc,
        [id]: { name }
      }
    ), {});
    const articles = initialData
      .filter(({ categories, acf }) => !categories.includes(9) && !categories.includes(42) && acf.post_type !== 'aside') // don't take components or advertiesements
      .map(data => {
        const { title, date, slug, categories, acf, tags } = data;
        const { default_fields } = acf;
        return {
          ...default_fields,
          image:
            default_fields.featured_image && default_fields.featured_image.name,
          title: title.rendered,
          date,
          slug: `/${slug}`,
          categories: categories.map(cat => postCategories[cat].name),
          influencer: categories.includes(4) && parsedTags[tags[0]] ? parsedTags[tags[0]].name : null,
        };
      });
    return {
      articles: articles.slice(0, 30)
    };
  } catch (e) {
    console.log(e, 'recentposts');
    return props;
  }
}

module.exports = {
  getInitialProps
};
